import { render, staticRenderFns } from "./InsuranceCompanyListView.vue?vue&type=template&id=8e98cad4"
import script from "./InsuranceCompanyListView.vue?vue&type=script&lang=js"
export * from "./InsuranceCompanyListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports